import { Routes } from '@angular/router';
import { RegisterActionTokenComponent } from './pages/action-token/register-action-token.component';
import { RegisterOfflinePlusComponent } from './pages/offline-plus/register-offline-plus.component';
import { RegisterQRCodeComponent } from './pages/qr-code/register-qr-code.component';
import { NoAuthGuard } from '@guards/no-auth.guard';

export const registerRoutes: Routes = [
  {
    // path => '/register-split/offline'
    path: 'offline',
    canActivate: [NoAuthGuard],
    component: RegisterOfflinePlusComponent,
  },
  {
    // path => '/register-split/token/:id'
    path: 'token/:id',
    component: RegisterActionTokenComponent,
  },
  {
    // path => '/register-split/qr'
    path: 'qr/:reference/:desktopKey/:checkSum',
    component: RegisterQRCodeComponent,
  },
  {
    // path => '/register-split/qr'
    path: 'qr/:reference/:desktopKey/:checkSum/:language',
    component: RegisterQRCodeComponent,
  },
];
